import React from "react";
import ContentLoader from "react-content-loader";

const RecommendedContactLoader = (props) => {
  return (
    <ContentLoader viewBox="0 0 90 160" height={140} width={90} style={{ marginRight: "5px" }} {...props}>
      <rect x="0" y="25" rx="50%" ry="50%" width="90" height="90" />
      <rect x="15" y="120" rx="10" ry="10" width="60" height="18" />
      <rect x="5" y="140" rx="10" ry="10" width="80" height="15" />
    </ContentLoader>
  );
};
export default RecommendedContactLoader;
